<template>
  <div class="auth-page loading">
    <main>
      <div class="content content--side">
        <header class="codrops-header uk-flex uk-flex-center">
          <img
            class="uk-margin-remove uk-text-center gmlogo"
            src="https://givemagic.s3.us-east-2.amazonaws.com/core-assets-live/givmagiclogo.png"
          />
        </header>
        <div class="form form-register">
          <div class="form__item">
            <label class="form__label" for="email">Workspace Name</label>
            <input
              class="form__input"
              type="text"
              v-model="form.workspace_name"
              @change="workspaceAppender()"
              id="name"
            />
          </div>
          <p
            v-if="showError && !this.form.workspace_name"
            class="form-error"
          >
            Please enter an organization name
          </p>
          <div class="form__item">
            <label class="form__label" for="email">Email Address</label>
            <input
              class="form__input"
              type="email"
              v-model="form.email"
              id="email"
            />
          </div>
          <p v-if="showError && !this.form.email" class="card-error">
            Please enter an email address
          </p>
          <div class="form__item">
            <label class="form__label" for="password">Password</label>
            <div class="form__input-wrap">
              <input
                class="form__input"
                type="password"
                v-model="form.password"
                id="password"
              />
              <p class="form__password-strength" id="strength-output"></p>
            </div>
            <p v-if="showError && !this.form.password" class="form-error">
              Please enter a password
            </p>
          </div>
          <div class="form__item form__item--actions">
            <span
              >Don't have an account?
              <router-link class="form__link" to="/register"
                >Register here</router-link
              >
            </span>
            <button
              v-if="!loginLoading"
              ref="loadingButton"
              class="signinbtn"
              @click="login()"
            >
              Log in
            </button>
            <button
              v-if="loginLoading"
              type="button"
              aria-labelledby="loading"
              class="signinbtn loading-login-btn"
            >
              <img
                src="https://givemagic.s3.us-east-2.amazonaws.com/core-assets-live/Spinner-1s-200px.svg"
                alt="Loader"
                width="40px"
              />
            </button>
            <p class="form-error" v-if="serverError">
              {{ serverError }}
            </p>
          </div>
        </div>
      </div>
      <div class="content content--side">
        <div class="poster" :style="'background-image:url(' + img + ')'"></div>
        <div class="canvas-wrap">
          <canvas></canvas>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import img from "../assets/images/register.jpg";
import authTypes from "../vuex/auth/auth.authTypes";
import { mapGetters, mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      form: { email: "", password: "", workspace_name: "" },
      img: img,
      serverError: "",
      showError: false
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      data: state => state.auth.data,
      type: state => state.auth.type,
      error: state => state.auth.error
    }),
    ...mapGetters(["loginLoading"])
  },
  watch: {
    type(newType) {
      if (newType === authTypes.LOGIN_FAILED) {
        this.serverError = this.error;
      }
      if (newType === authTypes.LOGIN_SUCCESS) {
        analytics.identify(`${this.data.first_name} ${this.data.last_name} (logged in)`,{
          user: `${this.data.first_name} ${this.data.last_name}`, // user first and last name
          user_email: `${this.data.email}`, // user email
          workspace: `${this.data.settings.workspace_name}` // workspace name
        });
        this.$router.push("/");

      }
      if (newType === authTypes.LOGIN_BLOCK) {
       this.$toasted.error("Don't Have Access", {
          icon: "error_outline",
          duration: 5000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  methods: {
    login() {
      this.showError = false;
      this.serverError = false;
      if (!this.validate()) return;
      const data = this.form;
      this.$store.dispatch("login", data);
    },
    validate() {
      const form = this.form;
      if (!form.email || !form.password || !form.workspace_name) {
        this.showError = true;
        return false;
      }
      return true;
    },
    workspaceAppender() {
      this.workspace = this.workspace + ".givemagic.ca";
      this.workspace = this.workspace
        .toLowerCase()
        .trim()
        .replace(/[\s\/]/g, "");
    }
  }
};
</script>

<style lang="scss" scoped>
*,
*::after,
*::before {
  box-sizing: border-box;
}

.form-register {
  position: relative;
  bottom: 50px;
}

.gmbg {
  background: #fdd7d0;
}

.signinbtn {
  background: #f2557a !important;
  font-size: 16px;
}

.gmlogo {
  max-width: 200px;
}
.login {
  display: flex;
  flex-direction: column;
  width: 300px;
}

.form-error {
  padding: 0px 5px;
  font-size: 13px;
  text-align: center;
  color: #e02020;
  margin: 0;
}
.loading-login-btn {
  padding: 0em 1.5em;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial,
    sans-serif;
  min-height: 100vh;
  color: #57585c;
  color: var(--color-text);
  background-color: #fff;
  background-color: var(--color-bg);
  height: 100vh;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.auth-page {
  --color-text: #000;
  --color-bg: #fff;
  --color-content-bg: #fff;
  --color-link: #000;
  --color-link-hover: #4bb3e7;
  --color-info: #000;
  --color-form-alt: #909090;
  --color-form-button-bg: #000;
  --color-form-button: #fff;
  --color-demo: #fff;
  --color-demo-hover: #fff;
  --color-github: #fff;
  --color-github-hover: #fff;
}

.js body.render {
  opacity: 1;
}

/* Page Loader */
.js .loading::before {
  content: "";
  position: fixed;
  z-index: 100000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-bg);
}

.js .loading::after {
  content: "";
  position: fixed;
  z-index: 100000;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  margin: -30px 0 0 -30px;
  pointer-events: none;
  border-radius: 50%;
  opacity: 0.4;
  background: var(--color-link);
  animation: loaderAnim 0.7s linear infinite alternate forwards;
}

@keyframes loaderAnim {
  to {
    opacity: 1;
    transform: scale3d(0.5, 0.5, 1);
  }
}

a {
  text-decoration: underline;
  color: var(--color-link);
  outline: none;
}

a:hover,
a:focus {
  color: var(--color-link-hover);
  outline: none;
  text-decoration: none;
}

.hidden {
  position: absolute;
  overflow: hidden;
  width: 0;
  height: 0;
  pointer-events: none;
}

/* Icons */
.icon {
  display: block;
  width: 1.5em;
  height: 1.5em;
  margin: 0 auto;
  fill: currentColor;
}

main {
  position: relative;
  width: 100%;
  display: flex;
  // flex-wrap: wrap;
}

.content {
  position: relative;
  min-height: 100vh;
}

.content--main {
  grid-template-columns: 50% 50%;
}

.content--full {
  width: 100vw;
}

.content--side {
  background: var(--color-content-bg);
  width: 550px;
  margin: 0;
  padding: 5vmin;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content--side + .content--side {
  justify-content: space-between;
  width: calc(100vw - 550px);
  margin-top: -99px;
}

.poster {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50% 50%;
}

/* Header */
.codrops-header {
  position: relative;
  z-index: 100;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  align-items: center;
  align-self: start;
  grid-area: header;
  justify-self: start;
  margin: 0 0 1rem 0;
}

.codrops-header__title {
  font-size: 1.5em;
  font-weight: bold;
  margin: 0;
  padding: 0;
}

.info {
  flex: none;
  width: 100%;
  margin: 1rem 0;
  color: var(--color-info);
}

.github {
  display: block;
  position: relative;
  color: var(--color-github);
  margin: 0 0 0 auto;
}

.github:hover,
.github:focus {
  color: var(--color-github-hover);
}

.demos {
  position: relative;
  display: block;
  text-align: right;
  margin: 0 0 0 auto;
}

.demo {
  font-weight: bold;
  color: var(--color-demo);
}

.demo:not(:last-child) {
  margin-right: 1.5rem;
}

.demo:hover,
.demo:focus {
  color: var(--color-demo-hover);
}

.demo span {
  white-space: nowrap;
  text-transform: lowercase;
  pointer-events: none;
}

a.demo--current {
  pointer-events: none;
  text-decoration: none;
}

/* Top Navigation Style */
.codrops-links {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0 1em 0 0;
  text-align: center;
  white-space: nowrap;
}

.codrops-icon {
  display: inline-block;
}

.codrops-icon:first-child {
  margin-right: 0.5rem;
}

.canvas-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

canvas {
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: -o-crisp-edges;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  width: 100%;
  height: 100%;
}

.form {
  margin: auto 0 0 0;
  position: relative;
}

.form__title {
  font-size: 1.5rem;
  margin: 0 0 3rem;
}

.form__item {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
}

.form__item:not(:last-child) {
  margin: 0 0 1.5rem;
}

.form__item--actions {
  color: var(--color-form-alt);
  margin-top: 3rem;
  font-size: 0.8rem;
  grid-template-columns: 3fr 1fr;
}

.form__label {
  font-weight: bold;
}

.form__input {
  padding: 1rem;
  width: 100%;
  border: 1px solid #ddd;
  font-weight: bold;
}

.form__input-wrap {
  position: relative;
}

.form__input:focus {
  border-color: #000;
  outline: none;
}

.form__password-strength {
  position: absolute;
  font-size: 0.75rem;
}

.form__link {
  font-weight: bold;
  white-space: nowrap;
}

.form__button {
  padding: 1rem;
  font-weight: bold;
  font-size: 1rem;
  border: 0;
  background: var(--color-form-button-bg);
  color: var(--color-form-button);
}

.form__button:focus {
  outline: none;
}

.demo-2 main {
  flex-direction: row-reverse;
}

.demo-2 .github,
.demo-2 .demos {
  margin: 0 auto 0 0;
}

@media screen and (max-width: 45em) {
  body {
    overflow: auto;
  }
  .content {
    height: auto;
    min-height: 0;
  }
  .content--side {
    width: 100vw;
  }
  .content--fixed {
    position: relative;
    z-index: 1000;
    display: block;
    padding: 0.85em;
  }
  .content--side + .content--side {
    width: 100vw;
    height: 100vw;
  }
}
</style>
